import { defaultForm } from '../pages/Dashboard/components/DashboardFilters/const';

const initialState = {
  dashboardForm: defaultForm,
};

const dashboardFilterSlice = (set) => ({
  ...initialState,
  setDashboardForm: (dashboardForm) => set({ dashboardForm }),
  resetDashboardFilter: () => set(initialState),
});

export default dashboardFilterSlice;
